<div class="energy-map-donated">
	<div class="grid-x grid-margin-x headline-wrapper">
		<div class="cell small-12 large-offset-1 large-10"><hr></div>
		<div class="cell small-12 large-offset-1 large-10 text-center">
			<h1 class="text-center" [innerHTML]="textkeyPrefix + '.energy.map.data_donation_successful.headline' | translate"></h1>
		</div>
		<div class="cell small-12 large-offset-1 large-10"><hr></div>
	</div>

	<div class="grid-x grid-margin-x">
		<div class="cell medium-8 large-offset-1 large-6">
			<p class="teaser" [innerHTML]="textkeyPrefix + '.energy.map.data_donation_successful.teaser' | translate"></p>
			<p class="text" [innerHTML]="textkeyPrefix + '.energy.map.data_donation_successful.text' | translate"></p>
		</div>
		<div class="cell medium-4">
			<img src="/gfx/all/energymap_erfolgreiche_spende.svg" alt="">
			<hr>
			<p class="hash-code text-center" [innerHTML]="hashCode"></p>
		</div>
	</div>

	<div class="grid-x grid-margin-x">
		<div class="cell shrink medium-3 large-2 large-offset-1">
			<a class="button darker-gray hollow" [routerLink]="lastStep"><i class="icon-chevron-left"></i></a>
		</div>
		<div class="cell auto medium-5 medium-offset-4 large-4">
			<a [routerLink]="nextStep" class="button primary inline-arrow-right">{{textkeyPrefix + '.energy.map.data_donation_successful.button' | translate}}</a>
		</div>
	</div>
</div>
